<template>
	<div>
		<div class="container-sm prodMain">
			<div class="row align-items-start">
				<div class="col-2"></div>

				<div class="col-2">&nbsp;</div>
				<div class="col-8">
					<div class="pageTitle">
						<img
							id="iconShoppingCart"
							class="img-fluid"
							src="images\shoppingCartIcon.png"
							onerror="this.onerror=null; this.src='images/placeholder_CompanyLogo.png'"
						/>
						<span class="spanTitle">Shopping Cart</span>
						<!-- <a
							href="#"
							class="btn btn-danger btn-sm butRemove"
							@click.prevent="clearCache()"
						>
							Clear cache
						</a> -->
					</div>

					<div v-if="message" class="alert alert-warning">
						<span class="main">{{ message }}</span>
					</div>
					<div v-if="message" class="support">
						If you are having difficulties please contact us for
						support at
						<a href="mailto:support@elearnology.ca"
							>info@elearnology.ca</a
						>
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="container-sm prodMain" v-if="!cart.CartItems.length">
			<div class="row align-items-start">
				<div class="col-3"></div>

				<div class="col-1">&nbsp;</div>
				<div class="col-8">
					<div class="emptyCartMessage">No items in cart.</div>
				</div>
			</div>
		</div> -->

		<div v-if="!cart.CartItems.length" class="container-sm prodMain">
			<div class="row cartLine">
				<div class="col-sm-3"></div>
				<div class="col-sm-1"></div>
				<div class="col-sm-8">
					<span class="taxLoader">
						<img src="images/Spinner-1s-200px.gif" />
						Product info loading...
					</span>
				</div>
			</div>
		</div>

		<div
			v-for="(CartItem, index) in cart.CartItems"
			:key="CartItem"
			class="container-sm prodMain"
		>
			<div class="row align-items-start">
				<div class="col-sm-3">
					<div class="brandLogoWrapper">
						<img
							id="brandLogo"
							class="img-fluid"
							:src="
								'images/' +
								CartItem.product.productLms.brand.imgLogo
							"
						/>
					</div>
					<div>
						<img
							id="prodImgThumnb"
							class="img-fluid"
							:src="
								'images/' +
								CartItem.product.productLms.brand
									.imgCartSideImage
							"
						/>
					</div>
				</div>
				<div class="col-sm-1"></div>
				<div class="col-sm-8">
					<div class="container-sm cartMain">
						<div class="row prodTitle">
							<div class="col-sm-11">
								{{ CartItem.product.name }}
							</div>
							<div class="col-sm-1 colRemoveButton">
								<a
									href="#"
									class="btn btn-danger btn-sm butRemove"
									@click.prevent="butRemoveItem(index)"
								>
									Remove
								</a>
							</div>
						</div>

						<div class="row prodPlanType">
							<div class="col-sm-3">
								<span class="label">Plan Type: </span>
							</div>

							<div class="col-sm-9">
								<div class="form-check form-switch">
									<!-- v-bind:id="index" -->

									<input
										v-if="
											CartItem.activeMonthsPerYear == 12
										"
										id="flexSwitchCheckDefault"
										v-model="CartItem.useAnnualBilling"
										class="form-check-input"
										type="checkbox"
										role="switch"
										@change="
											checkBillingType($event, index)
										"
									/>

									<label
										v-if="
											CartItem.activeMonthsPerYear == 12
										"
										class="form-check-label planTypeLabel"
										for="flexSwitchCheckDefault"
										>{{ CartItem.annualBillingText }}</label
									>
									<label
										v-if="CartItem.activeMonthsPerYear < 12"
										class="form-check-label planTypeLabelLeft"
										for="flexSwitchCheckDefault"
										>{{ CartItem.annualBillingText }}</label
									>
								</div>
							</div>
						</div>

						<div class="row prodDesc">
							<div class="col-sm-3">
								<span class="label">Description: </span>
							</div>

							<div class="col-sm-9">
								<span>
									{{ CartItem.Description }}
								</span>
							</div>
						</div>

						<div class="row prodFee">
							<div class="col-sm-3">
								<span class="label">Fee: </span>
							</div>

							<div class="col-sm-9">
								<span>{{ getFeeLine(CartItem) }}</span>
							</div>
						</div>

						<div
							v-if="parseInt(CartItem.activeMonthsPerYear) < 12"
							class="row prodFee"
						>
							<div class="col-sm-3">
								<span class="label">Active Months: </span>
							</div>

							<div class="col-sm-9">
								<span class="subLabel">
									This plan includes LMS access for
									<b>
										{{ CartItem.activeMonthsPerYear }}
										month(s).
									</b>
									within the next year.
								</span>
								<span class="subLabel">
									Please click to select your months.
								</span>
							</div>
						</div>

						<div
							v-if="parseInt(CartItem.activeMonthsPerYear) < 12"
							class="row prodFee"
						>
							<div class="col-sm-12 prodMain monthGroup">
								<div
									class="btn-group"
									role="group"
									aria-label="Basic checkbox toggle button group"
								>
									<template
										v-for="am in CartItem.activeMonthList"
										:key="am.monthOrder"
									>
										<input
											:id="'btncheck' + am.monthOrder"
											v-model="am.value"
											type="checkbox"
											class="btn-check"
											autocomplete="off"
											@change="
												chkMonth(
													am.monthOrder,
													CartItem,
													$event
												)
											"
										/>
										<label
											class="btn btn-secondary"
											:for="'btncheck' + am.monthOrder"
										>
											{{ am.name }}
										</label>
									</template>
								</div>
							</div>

							<div
								v-if="monthMessage"
								class="alert alert-warning"
							>
								<span class="main">{{ monthMessage }}</span>
							</div>
						</div>

						<div
							v-if="parseInt(CartItem.activeMonthsPerYear) < 14"
							class="row prodFee"
						>
							<div class="col-sm-3">
								<span class="label"></span>
							</div>

							<div class="col-sm-9">
								<span class="note">
									Note: LMS Portal subscriptions are sold in
									packages of 100, 200, or 500 user accounts.
									User accounts are not sold separately.
								</span>
							</div>
						</div>

						<!-- <div class="row cartLine">
							<div class="col-sm-8 label"></div>
							<div class="col-sm-4 fee">
								<span class="feeBlock">{{ formatCurrency(CartItem.price) }}</span>

								<span class="billAnnual" v-if="CartItem.useAnnualBilling"
									>(billed annually)</span
								>

								<span class="billAnnual" v-if="!CartItem.useAnnualBilling"
									>(cost per year)</span
								> 
							</div>
						</div> -->

						<div
							v-if="CartItem.useAnnualBilling"
							class="row cartLine"
						>
							<div class="col-sm-8 label"></div>
							<div class="col-sm-4 fee">
								<span class="feeBlock">{{
									formatCurrency(CartItem.price)
								}}</span>
								<span class="billAnnual"
									>(billed annually)</span
								>
							</div>
						</div>

						<div
							v-if="!CartItem.useAnnualBilling"
							class="row cartLine"
						>
							<div class="col-sm-8 label"></div>
							<div class="col-sm-4 fee">
								<span class="feeBlock">{{
									formatCurrency(CartItem.price / 12)
								}}</span>
								<span class="billAnnual">(billed monthly)</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container-sm prodMain">
			<div class="row">
				<div class="col-3"></div>

				<div class="col-1"></div>
				<div class="col-8">
					<div v-if="!cart.Coupon" class="prodCoupon">
						<div class="input-group mb-3">
							<input
								id="txtCouponCode"
								v-model="inpCouponCode"
								type="text"
								class="form-control"
								placeholder="Coupon Code"
								aria-label="Coupon Code"
								aria-describedby="basic-addon2"
							/>
							<div class="input-group-append">
								<button
									class="btn btn-primary"
									type="button"
									@click.prevent="checkCouponCode()"
								>
									Apply Coupon
								</button>
							</div>
						</div>
					</div>

					<div v-if="couponMessage" class="couponMessage">
						{{ couponMessage }}
					</div>

					<div v-if="cart.Coupon" class="row cartLine">
						<div class="col-sm-8 label">
							<span>Discount</span>

							<div v-if="cart.Coupon">
								<div class="discountDisc">
									Coupon Applied: {{ cart.Coupon.Code }}
								</div>
								<div class="discountDisc">
									Discount Type: {{ cart.Coupon.CouponType }}
									{{ cart.Coupon.DiscAmt }}
								</div>
								<div class="discountDisc">
									<a
										href="#"
										class="btn btn-danger btn-sm butRemove"
										@click.prevent="butRemoveDiscount()"
										>Remove</a
									>
								</div>
							</div>
						</div>
						<div class="col-sm-4 fee discAmt">
							<span>{{ formatCurrency(cart.Discount) }}</span>
						</div>
					</div>

					<div class="row cartLine">
						<div class="col-sm-8 label">Subtotal</div>
						<div class="col-sm-4 fee">
							<span class="feeBlock">{{
								formatCurrency(cart.Subtotal)
							}}</span>
							<!-- <span class="billAnnual">(billed annually)</span> -->
						</div>
					</div>

					<div class="row cartLine">
						<div class="col-sm-8 label">Taxes</div>
						<div class="col-sm-4 fee">
							<span></span>
						</div>
					</div>

					<div v-if="taxesLoaded">
						<!-- here put a spinner or whatever you want to indicate that a request is in progress -->

						<div
							v-for="(TaxRate, index) in cart.TaxRates"
							:key="index"
							class="row cartLine"
						>
							<div class="col-sm-8 taxLabel">
								{{ TaxRate.display_name }}
							</div>
							<div class="col-sm-4 fee">
								<span>{{
									formatCurrency(TaxRate.tax_amt)
								}}</span>
							</div>
						</div>
					</div>

					<div v-else>
						<!-- request finished -->

						<div class="row cartLine">
							<div class="col-sm-8 taxLabel"></div>
							<div class="col-sm-4 fee">
								<span class="taxLoader">
									<img src="images/Spinner-1s-200px.gif" />
									Taxes loading...
								</span>
							</div>
						</div>
					</div>

					<div class="row cartLine">
						<div class="col-sm-8 label">Total</div>
						<div class="col-sm-4 fee">
							<span>{{ formatCurrency(cart.Total) }}</span>
						</div>
					</div>

					<div class="row footCommandRow">
						<div class="col-sm-7"></div>
						<div class="col-sm-5">
							<a
								href="#"
								class="btn btn-primary butCheckOut"
								@click="butNext()"
								>Check Out</a
							>
						</div>
					</div>

					<div class="row footLinksRow">
						<div class="col-sm-12">
							<a href="#" class="" @click="butPrivacy()"
								>Privacy Policy</a
							>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- <script src="https://unpkg.com/vue"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/vuex/2.5.0/vuex.min.js"></script>
<script src="https://unpkg.com/axios/dist/axios.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js"
integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p"
crossorigin="anonymous"></script>
<script type="module" src="classes/Cart.js"></script>
<script type="module" src="vueApp.js"></script>-->
	</div>
</template>

<script>
import {
	Cart,
	CartItem,
	Coupon,
	TaxRate,
	CartUtils,
} from "@/components/classes/Cart.js";

// import axios from "axios";
import * as Sentry from "@sentry/vue";

var formatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
	// These options are needed to round to whole numbers if that's what you want.
	//minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
	//maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
const inpIsAnnualBilling = params["annualbilling"] === "true";

let productControllerURL = "";
// eslint-disable-next-line no-unused-vars
let discountControllerURL = "";
let billingControllerURL = "";
let apiKey = "";

export default {
	name: "Cart",
	emits: ["eventname"],

	setup() {},
	data() {
		return {
			products: [],
			customVar: 0,
			cart: new Cart(),
			inpCouponCode: "",
			custResponse: [],
			doneInit: false,
			taxesLoaded: false,
			message: "",
			activeMonthList: [],
			monthMessage: "",
			couponMessage: "",
			productLoaded: false,
		};
	},

	computed: {},

	watch: {
		cart: {
			handler(newCart) {
				// if(this.doneInit==true){

				const parsed = JSON.stringify(newCart);
				localStorage.setItem("cart", parsed);
				// }
			},

			deep: true,
		},
		// custResponse: {
		//     handler(cr){
		//         console.log(cr);
		//     }

		// }
	},

	mounted() {
		try {
			productControllerURL = this.apiBaseUrl + "Product/GetSingle/";
			discountControllerURL = this.apiBaseUrl + "Coupon/GetSingle/";
			billingControllerURL = this.apiBaseUrl + "Billing/";
			apiKey = this.apiKey;

			//wipe cart for testing
			localStorage.removeItem("cart");
			localStorage.removeItem("taxrates");
			localStorage.removeItem("upcomingInv");

			if (localStorage.getItem("cart")) {
				let uc = new CartUtils();
				this.cart = uc.reviveCartObj();
				this.cart.updateTotals();
				this.taxesLoaded = true;
			} else {
				// var ctx = this;

				//function runs fetch with callbacks never returns a value here
				AddProductToCart(this);

				// AddProductToCart(this).then((response) => {
				// 	if (response === undefined) {
				// 		throw new Error(
				// 			"AddProductToCart response is undefined"
				// 		);
				// 	}
				// 	if (response.status == 200) {
				// 		ctx.productLoaded = true;
				// 	} else {
				// 		ctx.message = "Error loading product info.";
				// 	}

				// 	// ctx.productLoaded = true;
				// });
			}
		} catch (e) {
			console.log(e);
			//add sentry catch error line here
			Sentry.captureException(e);
		}
	},

	methods: {
		clearCache: function () {
			try {
				localStorage.removeItem("cart");
				localStorage.removeItem("taxrates");
				localStorage.removeItem("upcomingInv");
				// localStorage.removeItem("customerDetail");
				location.reload();
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		chkMonth(monthOrder, Cart, event) {
			try {
				let numActiveMonths = 0;
				for (const e of Cart.activeMonthList) {
					if (e.value == true) {
						numActiveMonths++;
					}
					console.log(e);
				}

				let objIndex = Cart.activeMonthList.findIndex(
					(obj) => obj.monthOrder == monthOrder
				);

				if (numActiveMonths > 4) {
					Cart.activeMonthList[objIndex].value = false;
				} else {
					Cart.activeMonthList[objIndex].value =
						event.currentTarget.checked;
				}
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		checkBillingType: function (e, index) {
			try {
				let ci = this.cart.CartItems[parseInt(index)];
				ci.useAnnualBilling = e.currentTarget.checked;

				updateBillingTypeLabel(this.cart, ci);
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		butRemoveItem: function (index) {
			try {
				this.cart.CartItems.splice(index, 1);
				this.cart.updateTotals();
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		checkCouponCode() {
			try {
				if (this.inpCouponCode != "") {
					// let url = discountControllerURL + this.inpCouponCode;
					// axios.get(discountControllerURL + this.inpCouponCode;).then(response => {

					//     if (response.data.length > 0) {

					//         let couponData = response.data[0]
					//         let newCoupon = new Coupon();
					//         newCoupon.Code = couponData.Code;
					//         newCoupon.DiscAmt = couponData.DiscAmt
					//         newCoupon.CouponType = couponData.CouponType.Name

					//         this.cart.Coupon = newCoupon;
					//         this.cart.updateTotals();
					//     }

					// });

					//   axios.get(billingControllerURL + this.inpCouponCode).then(response => {

					//     if (response.data.length > 0) {

					//         // let couponData = response.data[0]
					//         // let newCoupon = new Coupon();
					//         // newCoupon.Code = couponData.Code;
					//         // newCoupon.DiscAmt = couponData.DiscAmt
					//         // newCoupon.CouponType = couponData.CouponType.Name

					//         // this.cart.Coupon = newCoupon;
					//         // this.cart.updateTotals();
					//     }

					// });
					// let upcomingInvoiceId="";

					// if (localStorage.getItem('upcomingInv')) {

					//         upcomingInvoiceId=
					//     }

					fetch(billingControllerURL + "LookupPromoCode", {
						method: "post",
						headers: {
							"Content-Type": "application/json",
							XApiKey: apiKey,
						},
						body: JSON.stringify({
							promoCode: this.inpCouponCode,
							// upcomingInvoiceId: ""
						}),
					})
						.then((response) => response.json())
						.then((data) => {
							let coupon = data.promotionCode.coupon;

							let newCoupon = new Coupon();

							newCoupon.Id = coupon.id;
							newCoupon.Code = data.promotionCode.code;

							if (coupon.amount_off != null) {
								newCoupon.DiscAmt = coupon.amount_off / 100;
								newCoupon.CouponType = "Fixed";
							} else {
								newCoupon.DiscAmt = coupon.percent_off;
								newCoupon.CouponType = "Percentage";
							}

							this.cart.Coupon = newCoupon;

							this.cart.updateTotals();

							this.couponMessage = "";

							// let upcomingInv = data.invoice;
							// const parsedInv = JSON.stringify(upcomingInv);
							// localStorage.setItem('upcomingInv', parsedInv);
						})
						.catch((error) => {
							// Your error is here!
							console.log(error);
							//display coupon not valid message
							this.couponMessage =
								"Sorry! That coupon code not valid.";
						});
				}
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},
		butRemoveDiscount() {
			try {
				this.cart.Coupon = null;
				this.cart.updateTotals();
				this.inpCouponCode = "";
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		getPrice: function (product) {
			try {
				let userPrice = parseFloat(product.productLms.UserPriceYear);
				let numUsers = parseInt(product.productLms.numUsers);
				let numMonths = parseInt(
					product.productLms.activeMonthsPerYear
				);
				let price = userPrice * numUsers * numMonths;
				return formatter.format(price);
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		getFeeLine: function (ci) {
			try {
				let userPrice = 0;

				if (ci.useAnnualBilling == true) {
					userPrice = parseFloat(ci.product.productLms.userPriceYear);
				} else {
					userPrice = parseFloat(
						ci.product.productLms.userPriceMonth
					);
				}

				let numUsers = parseInt(ci.product.productLms.numUsers);
				let numMonths = parseInt(
					ci.product.productLms.activeMonthsPerYear
				);
				let feeLine = "";
				let total = parseFloat(userPrice * numUsers);

				if (ci.activeMonthsPerYear == 12) {
					feeLine =
						numUsers +
						" user accounts x " +
						formatter.format(userPrice) +
						" = " +
						formatter.format(total) +
						" billed";

					if (ci.useAnnualBilling == true) {
						feeLine += " annually";
					} else {
						feeLine += " monthly";
					}
				} else {
					//short plans
					feeLine =
						numUsers +
						" user accounts x " +
						formatter.format(userPrice) +
						" x " +
						numMonths +
						" months " +
						// " = " +
						// formatter.format(total * numMonths) +
						" billed";

					if (ci.useAnnualBilling == true) {
						feeLine += " annually";
					}
				}

				return feeLine;
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},
		formatCurrency: function (price) {
			try {
				let priceString = formatter.format(price);
				return priceString;
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},
		countMonthsSelected() {
			try {
				let numActiveMonths = 0;

				if (this.cart != null) {
					for (const ci of this.cart.CartItems) {
						if (ci.activeMonthList != null) {
							for (const e of ci.activeMonthList) {
								if (e.value == true) {
									numActiveMonths++;
								}
							}
						}
					}
				}

				// }

				return numActiveMonths;
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},
		butNext() {
			try {
				//if lms is sunshine plane make sure 4 months are selected first
				if (this.cart.CartItems[0].activeMonthsPerYear < 12) {
					if (
						this.countMonthsSelected() ==
						this.cart.CartItems[0].activeMonthsPerYear
					) {
						this.$emit("eventname", "CustomerDetails");
					} else {
						this.monthMessage =
							"Must choose " +
							this.cart.CartItems[0].activeMonthsPerYear +
							" months before proceeding.";
					}
				} else {
					this.$emit("eventname", "CustomerDetails");
				}
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},
		butPrivacy() {
			try {
				this.$emit("eventname", "Privacy");
			} catch (e) {
				console.log(e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},
	},
};

async function AddProductToCart(ctx) {
	try {

		let newCart = new Cart();

		// if (localStorage.getItem('cart')) {
		//     try {
		//         newCart = reviveCartObj()
		//     } catch (e) {
		//         localStorage.removeItem('cart');
		//     }
		// }

		// if (localStorage.getItem('taxrates')) {
		//     try {
		//         // newCart = reviveCartObj()
		//     } catch (e) {
		//         localStorage.removeItem('taxrates');
		//     }
		// }

		// if (localStorage.getItem('upcomingInv')) {
		//     try {
		//         // newCart = reviveCartObj()
		//     } catch (e) {
		//         localStorage.removeItem('upcomingInv');
		//     }
		// }

		//wipe cart for testing
		// localStorage.removeItem("cart");
		// localStorage.removeItem("taxrates");
		// localStorage.removeItem("upcomingInv");

		//get data for single product
		//need to get StripeProdid/PriceId as well
		// var self = context;

		if (params["productid"] != undefined) {
			const inpProductId = parseInt(params["productid"]);

			// let config = {
			// 	headers: {
			// 		XApiKey: apiKey,
			// 	},
			// };
			// let data = {
			// 	// HTTP_CONTENT_LANGUAGE: self.language,
			// };

			// axios({
			// 	method: "get",
			// 	url: `https://example.com/comments/${commentId}/vote/up/`,
			// 	headers: {
			// 		"Content-Type": "application/json",
			// 		"X-API-KEY": "XXX",
			// 		Authorization: localStorage.getItem("access_token"),
			// 	},
			// 	data: {},
			// });

			// axios
			// 	.get(
			//         productControllerURL + inpProductId,
			//         null,
			//         config
			//     )

			// let token = btoa(apiKey + "_" + "salt" + "_" + Date.now());

			fetch(productControllerURL + inpProductId, {
				method: "get",
				headers: {
					XApiKey: apiKey,
					// authToken: token,
				},
			})
				.then((response) => response.json())
				.then((data) => {
					// .then((response) => {

					ctx.products = data;

					for (var key of Object.keys(ctx.products)) {
						let p = ctx.products[key];

						if (
							// p.stripeProductId != null && //not sure why this is empty now......
							p.stripePriceIdYearly != null ||
							p.stripePriceIdMonthly != null
						) {
							let ci = new CartItem();
							ci.isMonthlyBillingAllowed =
								p.isMonthlyBillingAllowed;
							ci.product = p;
							ci.updatePrice();
							ci.useAnnualBilling = inpIsAnnualBilling;

							ci.Description = p.description;

							ci.stripeProdId = p.stripeProductId;
							ci.stripePriceIdYearly = p.stripePriceIdYearly;
							ci.stripePriceIdMonthly = p.stripePriceIdMonthly;

							ci.activeMonthsPerYear = 12;
							if (p.productLms.activeMonthsPerYear != null) {
								ci.activeMonthsPerYear =
									p.productLms.activeMonthsPerYear;
							}

							if (!p.isMonthlyBillingAllowed) {
								ci.useAnnualBilling = true;
							}

							let cartHasProductID = false;

							newCart.CartItems.forEach((el) => {
								if (el.product.Id == ci.product.Id) {
									cartHasProductID = true;
								}
							});

							if (!cartHasProductID) {
								updateBillingTypeLabel(newCart, ci);

								newCart.CartItems.push(ci);

								if (!localStorage.getItem("taxrates")) {
									// var self2 = ctx;
									//create init cust data and get tax rate for first item in cart
									CreateStripeCustomerGetTaxRate(
										newCart.CartItems[0]
									).then((response) => {
										ctx.custResponse = response;

										if (response.invoice != null) {
											let taxrates =
												response.invoice
													.total_tax_amounts;
											const parsedTaxRates =
												JSON.stringify(taxrates);
											localStorage.setItem(
												"taxrates",
												parsedTaxRates
											);

											let upcomingInv = response.invoice;
											const parsedInv =
												JSON.stringify(upcomingInv);
											localStorage.setItem(
												"upcomingInv",
												parsedInv
											);

											// console.log(taxrates);
											// console.log(this.custResponse.invoice);

											taxrates.forEach((el) => {
												let tr = new TaxRate();
												tr.tax_type =
													el.tax_rate.tax_type;
												tr.display_name =
													el.tax_rate.display_name;
												tr.percentage =
													el.tax_rate.percentage;

												newCart.TaxRates = [];
												newCart.TaxRates.push(tr);
											});

											newCart.updateTotals();
											// this.doneInit = true;
											ctx.cart = newCart;
											// return newCart;

											ctx.taxesLoaded = true;
											//hack because reactivity not working after this data pull
											ctx.$forceUpdate();
										}
									});
								} else {
									//update cart tax rates from stored values
									// taxrates.forEach(el => {

									//     let tr = new TaxRate();
									//     tr.tax_type = el.tax_rate.tax_type;
									//     tr.display_name = el.tax_rate.display_name;
									//     tr.percentage = el.tax_rate.percentage;

									//     newCart.TaxRates=[];
									//     newCart.TaxRates.push(tr);

									// });

									newCart.updateTotals();
									ctx.cart = newCart;
									//hack because reactivity not working after this data pull
									ctx.$forceUpdate();
								}
							}
						} else {
							ctx.message =
								"Hmmm, looks like we were not able to load product info from our payment processor.";
						}
					}

					newCart.updateTotals();

					ctx.cart = newCart;

					// return newCart;
				})
				.catch((e) => {
					console.error("Error:", e);
					ctx.message =
						"Oops, could not connect to our remote api. " + e;
					Sentry.captureException(e);
				});
		}
	} catch (e) {
		console.error(e);
		//add sentry catch error line here
		Sentry.captureException(e);
	}
}

function updateBillingTypeLabel(cart, ci) {
	try {
		let pLms = ci.product.productLms;

		if (ci.useAnnualBilling) {
			if (pLms.activeMonthsPerYear == 12) {
				let savingAmt =
					pLms.totalPriceMonth * pLms.activeMonthsPerYear -
					pLms.totalPriceYear;
				ci.annualBillingText =
					"Annual (save " + formatter.format(savingAmt) + ")";
			} else {
				ci.annualBillingText = "Annual";
			}
		} else {
			ci.annualBillingText = "Monthly (no discount)";
		}

		ci.updatePrice();

		cart.updateTotals();
	} catch (e) {
		console.log(e);
		//add sentry catch error line here
		Sentry.captureException(e);
	}
}

async function CreateStripeCustomerGetTaxRate(ci) {
	try {
		//     const getIP = axios.get('https://www.cloudflare.com/cdn-cgi/trace').then(r => {

		//         // console.log(r.data);
		//         return r.data;

		//     });

		// console.log(getIP);

		console.log("starting CreateStripeCustomerGetTaxRate function");

		//use Cloudflare's free service to get public IP Address of user
		const getIpResponse = await fetch(
			"https://www.cloudflare.com/cdn-cgi/trace"
		).then(function (response) {
			return response.text().then(function (text) {
				return text
					.trim()
					.split("\n")
					.reduce(function (obj, pair) {
						pair = pair.split("=");
						return (obj[pair[0]] = pair[1]), obj;
					}, {});
			});
		});
		let getIP = getIpResponse["ip"];

		//     //user free tier of IpAPI.co's service to get location data
		//     //free tier includes up to 1000 calls/day
		//     //1st paid tier is $15/month for 2000 calls/day

		console.log("starting ipapi.co");

		const getLocData = await fetch(
			"https://ipapi.co/99.244.33.33/json/"
		).then(function (response) {
			return response.json();
		});

		let countryCode = getLocData["country_code"];
		let stateCode = getLocData["region_code"];
		let cityCode = getLocData["city"];
		let postalCode = getLocData["postal"];

		//     // Create a customer. This will also set a cookie on the server
		//     // to simulate having a logged in user.
		let priceId = "";

		if (ci.useAnnualBilling == true) {
			priceId = ci.product.stripePriceIdYearly;
		} else {
			priceId = ci.product.stripePriceIdMonthly;
		}

		// let bodyJSON = {
		// 	Email: "email@incompleteorder.com",
		// 	IpAddress: getIP,
		// 	IpCountry: countryCode,
		// 	IpCity: cityCode,
		// 	IpState: stateCode,
		// 	IpPostal: postalCode,
		// 	PriceId: priceId,
		// 	Address: "",
		// 	StripeCustId: "",
		// 	StripeCouponId: "",
		// 	FirstName: "",
		// 	LastName: "",
		// };

		let bodyJSON = {
			email: "email@incompleteorder.com",
			ipAddress: getIP,
			ipCountry: countryCode,
			ipCity: cityCode,
			ipState: stateCode,
			ipPostal: postalCode,
			priceId: priceId,
			address: "",
			stripeCustId: "",
			stripeCouponId: "",
			firstName: "",
			lastName: "",
		};

		let bodySTR = JSON.stringify(bodyJSON);

		// bodySTR = bodySTR.replace("'{","{").replace("}'","}");

		//  "email": "string",
		//   "ipAddress": "string",
		//   "ipCountry": "string",
		//   "ipCity": "string",
		//   "ipState": "string",
		//   "ipPostal": "string",
		//   "priceId": "string",
		//   "address": "string",
		//   "stripeCustId": "string",
		//   "stripeCouponId": "string",
		//   "firstName": "string",
		//   "lastName": "string"

		// let test = "";

		console.log("starting CreateCustomerGetTaxRate");

		// const custDataTaxRate = await fetch(billingControllerURL + "CreateCustomerGetTaxRate" + "?inputString="+bodyJSON, {
		const custDataTaxRate = await fetch(
			billingControllerURL + "CreateCustomerGetTaxRate",
			{
				method: "post",
				headers: {
					"Content-Type": "application/json",
					XApiKey: apiKey,
				},
				body: bodySTR,
			}
		)
			.then(function (response) {
				return response.json();
			})
			.catch((error) => {
				// Your error is here!
				console.log(error);
			});

		return custDataTaxRate;
	} catch (e) {
		console.log(e);
		//add sentry catch error line here
		Sentry.captureException(e);
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a,
a:hover {
	/* background-color: #a9cf3c; */
	color: #a9cf3c;
	/* font-weight: 600; */
	font-family: Lato Bold, Arial, Helvetica, sans-serif;
	text-decoration: none;
}
a:hover {
	color: #aaa;
}
.prodMain {
	margin-bottom: 50px;
	max-width: 1000px;
}

.prodMain .pageTitle {
	font-size: 30px;
	margin-bottom: 20px;
}

.prodMain .row {
	margin: 0px;
}

.brandLogoWrapper {
	text-align: center;
}
#brandLogo {
	margin-bottom: 20px;
	/* min-height:100px; */
	/* width:90px;
    height:90px;
    margin-right:auto;
    margin-left: auto; */
	width: 100%;
	max-width: 90px;
}
#prodImgThumnb {
	margin-bottom: 50px;
	min-height: 100px;
	/* width: 240px; */
	/* height: 260px; */
	width: 100%;
}
.prodMain .prodTitle {
	font-size: 20px;
	margin-bottom: 30px;
	border-bottom: 1px grey solid;
}

.cartLine {
	font-size: 16px;
	margin-bottom: 10px;
	border-top: 1px #ddd solid;
	padding-top: 10px;
	padding-bottom: 10px;
}
.cartLine .label {
	font-weight: 400;
}

.cartLine .taxLabel {
	font-weight: 100;
	padding-left: 50px;
}
.cartLine .fee {
	text-align: right;
}
.floatSwitch {
	float: left;
}
.prodMain .label {
	font-weight: 600;
	font-family: Lato Bold, Arial, Helvetica, sans-serif;
	margin-bottom: 0px;
	padding-bottom: 0px;
}
.prodMain .subLabel {
	font-weight: 400;

	margin-top: 0px;
	padding-top: 0px;
	/* margin-bottom: 5px; */
}
.prodMain .subLabel b {
	font-weight: 600;
	color: #a9cf3c;
}

.cartMain .row {
	margin-bottom: 20px;
}

.prodPlanType {
	/* margin-bottom: 20px !imp ortant; */
	/* border:1px red solid; */
}
.prodPlanType div {
	padding: 0px;
	/* padding-left: 12px; */
	/* border:1px red solid;  */
}
.planTypeLabel {
	margin-left: 10px;
}
.planTypeLabelLeft {
	margin-left: 0px;
}
.prodDesc {
	margin-bottom: 20px;
}
.prodFee {
	margin-bottom: 20px;
}

.prodCoupon {
	margin-bottom: 20px;
}

.billAnnual {
	font-size: 12px;
	display: block;
	clear: both;
	color: rgb(90, 89, 89);
}
.feeBlock {
	display: block;
	clear: both;
}
.prodMain .footCommandRow {
	border-top: 1px #ddd solid;
	margin-top: 40px;
	padding-top: 20px;
	text-align: right !important;
	margin-bottom: 60px;
}

.prodMain .footLinksRow {
	border-top: 1px #ddd solid;
	margin-top: 40px;
	padding-top: 10px;
	text-align: left !important;
	margin-bottom: 40px;
}
a.butRemove {
	font-size: 8px;
	padding: 2px;
	color: white;
}

.form-switch .form-check-input {
	/* width: 2em; */
	margin-left: 0em;
}
.form-check .form-check-input {
	/* float: left; */
	margin-left: 0;
}
/* .planTypeLabel {

} */

.btn-primary,
.btn-primary:hover {
	background-color: #a9cf3c;
	border-color: #a9cf3c;
	color: white;
	font-weight: 600;
	font-family: Lato Bold, Arial, Helvetica, sans-serif;
}

.butCheckOut,
.butCheckOut:hover {
	width: 100%;
}

.row {
	--bs-gutter-x: 0rem;
}
.iconShoppingCart {
	padding: 0px;
	margin: 0px;
	margin-right: 10px;
}

.colRemoveButton {
	text-align: right;
}
.discountDisc {
	font-size: 12px;
	color: #a9cf3c;
	font-style: italic;
}
.discAmt {
	color: #a9cf3c;
}

.taxLoader {
	height: 40px;
	display: block;
}
.taxLoader img {
	width: auto;
	height: 100%;
}

.support {
	color: #aaa;
	display: block;
	margin-top: 0px;
	padding: 0px;
	padding-left: 15px;
	padding-right: 15px;

	/*
    border-top:1px #ccc solid;
    padding-top:5px;*/
}

.support a {
	color: #a9cf3c;
	text-decoration: none;
}

.btn-check:active + .btn-secondary,
.btn-check:checked + .btn-secondary,
.btn-secondary.active,
.btn-secondary:active,
.show > .btn-secondary.dropdown-toggle {
	color: #fff;
	background-color: #a9cf3c;
	border-color: #a9cf3c;
}
.monthGroup {
	/* margin-top: 10px; */
	margin-bottom: 15px;
}

.spanTitle {
	margin-left: 20px;
}

/* .monthGroup .btn-group {

}  */

.monthGroup .btn-group-vertical > .btn,
.btn-group > .btn {
	width: 55px;
}
.btn-group > .btn-group:not(:first-child) > .btn,
.btn-group > .btn:nth-child(n + 3),
.btn-group > :not(.btn-check) + .btn {
	border-top-right-radius: 4px;
}

.prodMain .note {
	display: block;
	font-size: 12px;
	line-height: 14px !important;
	color: #a9cf3c;
	font-style: italic;
}

.prodMain .couponMessage {
	display: block;
	font-size: 14px;
	line-height: 16px !important;
	color: orange;
	font-weight: bold;
	/* font-style: italic; */
	padding: 10px;
	border: 1px orange solid;
	margin-bottom: 40px;
	border-radius: 4px;
}

.btn-group > .btn-group:not(:first-child) > .btn {
	border-top-right-radius: 0px;
}

/* .btn-group > .btn-group(:last-child) > .btn {
	border-top-right-radius: 4px;
} */

.btn-group > .btn-group:last-child > .btn {
	border-top-right-radius: 4px;
}
@media screen and (min-width: 769px) and (max-width: 1014px) {
	.btn-group > .btn-group:not(:last-child) > .btn,
	.btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
		border-bottom-left-radius: 0;
	}
	.btn-group > .btn-group:not(:first-child) > .btn,
	.btn-group > .btn:nth-child(n + 3),
	.btn-group > :not(.btn-check) + .btn {
		border-top-right-radius: 0;
	}
	.monthGroup .btn-group {
		/* width: 100%; */
		flex-wrap: wrap;
	}
	.monthGroup .btn-group-vertical > .btn,
	.btn-group > .btn {
		width: 16.66%;
	}
}

@media screen and (max-width: 768px) {
	.monthGroup .btn-group {
		width: 100%;
		flex-wrap: wrap;
	}

	.monthGroup .btn-group-vertical > .btn,
	.btn-group > .btn {
		width: 25%;
	}
	.btn-group > .btn-group:not(:last-child) > .btn,
	.btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
		border-bottom-left-radius: 0;
	}
	.btn-group > .btn-group:not(:first-child) > .btn,
	.btn-group > .btn:nth-child(n + 3),
	.btn-group > :not(.btn-check) + .btn {
		border-top-right-radius: 0;
	}
}
</style>
